export type PendingRefund = { id: string; points: string; reason: string };
// Persist before sending. A denied storage write prevents an unresumable refund.
export function readPendingRefund(key: string): PendingRefund | null {
  if (typeof window === "undefined" || !window.sessionStorage) return null;
  const raw = window.sessionStorage.getItem(key);
  if (!raw) return null;
  const value = JSON.parse(raw) as PendingRefund;
  if (!value || typeof value.id !== "string" || typeof value.points !== "string" || typeof value.reason !== "string") throw new Error("Invalid saved refund. Review the ledger before clearing browser storage.");
  return value;
}
export function savePendingRefund(key: string, command: PendingRefund) {
  window.sessionStorage.setItem(key, JSON.stringify(command));
}
export function clearPendingRefund(key: string) { window.sessionStorage.removeItem(key); }
